import React from 'react';
import { Modal } from '@/components/feedback/modal';
import { TertiaryButton, WarningButton } from '@/components/display/button';
import { HandRaised } from '@/icons/hand-raised';
import { CampaignIO } from 'shared/src/api/io-types';

type Props = {
  io: CampaignIO | null;
  onClose: () => void;
  onConfirm: () => void;
};

export function ExportConfirmationModal({ io, onClose, onConfirm }: Props) {
  if (!io) return null;

  const ioName = io.io_name || 'Unnamed IO';
  const statusPhrase =
    io.status === 'completed'
      ? 'has been Completed and signed by the client.'
      : 'is Out for Signature.';

  return (
    <Modal
      open={!!io}
      setOpen={open => {
        if (!open) onClose();
      }}
      header={
        <div className="flex flex-col items-center gap-2 rounded-t-2xl bg-yellow-200 py-6">
          <HandRaised />
          <h2 className="text-center text-2xl font-semibold leading-[30px] text-yellow-700">
            Exporting will overwrite this
            <br />
            IO&apos;s line items in Zoho
          </h2>
        </div>
      }
      content={
        <div className="px-10 pt-6 text-base leading-6 text-gray-700">
          <p>
            {ioName} <span className="font-bold">{statusPhrase}</span>
          </p>
          <p className="mt-4">
            Exports to update it <span className="text-red-600">should not include</span> changes to
            overall campaign price, any unit price, unit price type, tactic, or moving campaign
            start or end dates to another calendar month.
          </p>
          <p className="mt-4">
            Confirm you want to export and overwrite to update these line items.
          </p>
        </div>
      }
      footer={
        <div className="flex gap-4 px-10 pb-4 pt-8">
          <TertiaryButton className="w-[190px] justify-center" onClick={onClose}>
            Cancel
          </TertiaryButton>
          <WarningButton className="flex-1 justify-center" onClick={onConfirm}>
            Confirm export
          </WarningButton>
        </div>
      }
    />
  );
}
